import { BRAND_NAME } from "../../../../../config/app/brandAssets";

/** Finish actions that trigger the thank-you popup. */
export const SIGN_PDF_FINISH_THANK_YOU_ACTIONS = {
  DOWNLOAD: "download",
  DOWNLOAD_LATER: "download_later",
  PRINT: "print",
  EMAIL: "email",
  SHARE: "share",
};

const SHARED_MARKETING = {
  headline: `Do more with ${BRAND_NAME}`,
  bullets: [
    "Protect PDFs with PDF Watermarker — logos, text, and dates in one click",
    "Clean up scans and IDs with AI Background Remover",
    "Sign your next agreement just as fast — no printer required",
  ],
  footer: "You're on a roll. Keep creating smarter, not harder.",
};

const ACTION_COPY = {
  [SIGN_PDF_FINISH_THANK_YOU_ACTIONS.DOWNLOAD]: {
    title: "Thank you for downloading!",
    message:
      "Your signed PDF is saved to your device and ready to share or archive.",
    icon: "↓",
  },
  [SIGN_PDF_FINISH_THANK_YOU_ACTIONS.DOWNLOAD_LATER]: {
    title: "Thanks — we'll be here when you are!",
    message:
      "Your document is signed and ready whenever you want to download it.",
    icon: "⏱",
  },
  [SIGN_PDF_FINISH_THANK_YOU_ACTIONS.PRINT]: {
    title: "Thank you for printing!",
    message:
      "Your signed copy is heading to the printer. No smudged scans required.",
    icon: "🖨",
  },
  [SIGN_PDF_FINISH_THANK_YOU_ACTIONS.EMAIL]: {
    title: "Thank you for emailing!",
    message:
      "Your email app is ready — attach your signed PDF and hit send.",
    icon: "✉",
  },
  [SIGN_PDF_FINISH_THANK_YOU_ACTIONS.SHARE]: {
    title: "Thank you for sharing!",
    message:
      "Your signed PDF is on its way. Fast signatures, zero friction.",
    icon: "↗",
  },
};

export function getSignPdfFinishThankYouContent(action) {
  const copy = ACTION_COPY[action] || ACTION_COPY[SIGN_PDF_FINISH_THANK_YOU_ACTIONS.DOWNLOAD];
  return { ...copy, marketing: SHARED_MARKETING };
}
